<template>
    <div class="col page-element">
        <b-modal ref="uploadFileModal" hide-footer title="Dodaj plik">
            <alert-loading v-if="uploadForm.loading"></alert-loading>
            <upload-file v-show="uploadForm.loading == false" ref="addFileForm" :post-action="uploadFileUrl" @loading="uploadForm.loading=$event" @success="hideModal()"></upload-file>
            <b-row>
                <b-col>
                    <b-button v-show="uploadForm.loading == false" class="mt-3" variant="primary" block @click="hideModal"><span>Anuluj</span><svg-icon name="back"/></b-button>
                </b-col>
                <b-col>
                    <b-button v-show="uploadForm.loading == false" class="mt-3" variant="default" block @click="sendFileForm"><span>Zapisz</span><svg-icon name="tick"/></b-button>
                </b-col>
            </b-row>
        </b-modal>
        <alert-loading v-if="loading"></alert-loading>
        <page-title v-if="!loading"><h3>Lista dokumentów</h3>
            <div class="page-title__buttons">
                <b-button @click="showModal" variant="default">
                    <span>Dodaj skan dokumentu</span>
                    <svg-icon name="plus"/>
                </b-button>

            </div>
        </page-title>
        <div v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Nazwa pliku</th>
                    <th>Opis</th>
                    <th>Typ</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in itemsWithType">
                    <td class="td-no_link">{{ item['originalName'] }}</td>
                    <td class="td-no_link">{{ item['name'] }}</td>
                    <td class="td-no_link">{{ item['type'] }}</td>
                    <td>
                        <a href="#" class="btn btn-icon" @click.prevent="downloadFile(item.id)">
                            <svg-icon name="download"/>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import http from  '../../utils/http'

  export default {
    data: function () {
      return {
        files: [],
        uploadForm: {
          loading: false
        }
      }
    },
    computed: {
      uploadFileUrl () {
        return '/customers/' + this.$route.params.id + '/upload'
      },
      itemsWithType () {
        let items = []
        let fileTypes = {}

        for (var i = 0; i < this.fileTypes.length; i++) {
          fileTypes[this.fileTypes[i]['@id']] = ({...this.fileTypes[i]})
        }

        for (var i = 0; i < this.items.length; i++) {
          items.push({
            ...this.items[i],
            type: fileTypes[this.items[i]['type']].name
          })
        }

        return items
      },
      ...mapGetters({
        error: 'customer/documentList/error',
        loading: 'customer/documentList/loading',
        items: 'customer/documentList/items',
        fileTypes: 'config/config/fileTypes',

      })
    },
    props: {
      id: {
        type: String,
        default: '',
        required: true
      }
    },
    created () {
      this.$store.dispatch('customer/documentList/getItems', this.id)
    },
    methods: {
      downloadFile(fileId){
        http.download('/download/debtor/attached-file/' + fileId );
      },
      showModal () {
        this.$refs.uploadFileModal.show()
        this.$refs.addFileForm.resetForm()
      },
      hideModal () {
        this.$refs.uploadFileModal.hide()
        setTimeout(() => this.$store.dispatch('customer/documentList/getItems', this.id), 500)
      },
      sendFileForm () {
        this.$refs.addFileForm.sendForm()

      }
    }
  }
</script>


// WEBPACK FOOTER //
// DocumentList.vue?25dfa6f1